import ReactExport from "@ibrahimrahmani/react-export-excel";

import IconButton from "@mui/material/IconButton";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const GeneradorExcelExpedientes = ({
  datos = [],
  tipo = "",
  tipo_tramite = "E",
  origen = "",
  origenId = "",
  destino = "",
  destinoId = "",
  rango = "",
}) => {
  const sinDatos =
    !Array.isArray(datos) ||
    datos.length === 0;

  const esPendiente =
    String(tipo).toLowerCase() ===
    "pendientes";

  const esExpediente =
    tipo_tramite === "E";

  const esTramite =
    tipo_tramite === "T";

  /*
   * Definición de columnas
   */
  const columnas = [];

  if (esExpediente) {
    columnas.push({
      titulo: "Expediente",
      campo: "expediente",
      ancho: 22,
      alineacion: "left",
    });
  }

  if (esTramite) {
    columnas.push({
      titulo: "Trámite",
      campo: "tramiteInterno",
      ancho: 22,
      alineacion: "left",
    });
  }

  columnas.push(
    {
      titulo: "Asunto",
      campo: "asunto",
      ancho: 45,
      alineacion: "left",
    },
    {
      titulo: "Iniciadores",
      campo: "iniciadores",
      ancho: 38,
      alineacion: "left",
    }
  );

  if (esPendiente) {
    columnas.push(
      {
        titulo: "Fecha",
        campo: "fechaMovimiento",
        ancho: 17,
        alineacion: "center",
      },
      {
        titulo: "Organismo de origen",
        campo: "organismoOrigen",
        ancho: 38,
        alineacion: "left",
      }
    );
  }

  columnas.push({
    titulo: "Folios",
    campo: "cant_folios",
    ancho: 12,
    alineacion: "center",
  });

  const totalColumnas =
    columnas.length;

  /*
   * Como la librería no combina celdas,
   * se coloca el texto en una columna central.
   */
  const columnaCentral =
    Math.floor(totalColumnas / 2);

  /*
   * Texto del organismo
   */
  let textoOrganismo = "";

  if (destino) {
    textoOrganismo =
      `Al organismo: ${destinoId} - ${destino}`;
  } else if (origen) {
    textoOrganismo =
      `Del organismo: ${origenId} - ${origen}`;
  }

  /*
   * Columnas del dataSet.
   *
   * Se dejan sin encabezado porque los encabezados
   * de la tabla se agregan manualmente dentro de data.
   */
  const columnasExcel =
    columnas.map((columna) => ({
      value: "",
      widthCh: columna.ancho,
    }));

  /*
   * Fila vacía
   */
  const crearFilaVacia = () =>
    Array.from(
      {
        length: totalColumnas,
      },
      () => ({
        value: "",
      })
    );

  /*
   * Título principal
   */
  const crearFilaTitulo = () =>
    Array.from(
      {
        length: totalColumnas,
      },
      (_, indice) => ({
        value:
          indice === columnaCentral
            ? `LISTADO DE ${
                String(tipo).toUpperCase() ||
                "EXPEDIENTES"
              }`
            : "",

        style: {
          font: {
            name: "Arial",
            sz: 16,
            bold: true,
            color: {
              rgb: "FF000000",
            },
          },

          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },

          border: {
            top: {
              style: "medium",
              color: {
                rgb: "FF000000",
              },
            },

            bottom: {
              style: "medium",
              color: {
                rgb: "FF000000",
              },
            },

            left:
              indice === 0
                ? {
                    style: "medium",
                    color: {
                      rgb: "FF000000",
                    },
                  }
                : undefined,

            right:
              indice ===
              totalColumnas - 1
                ? {
                    style: "medium",
                    color: {
                      rgb: "FF000000",
                    },
                  }
                : undefined,
          },
        },
      })
    );

  /*
   * Organismo centrado
   */
  const crearFilaOrganismo = () =>
    Array.from(
      {
        length: totalColumnas,
      },
      (_, indice) => ({
        value:
          indice === columnaCentral
            ? textoOrganismo
            : "",

        style: {
          font: {
            name: "Arial",
            sz: 11,
            bold: true,
            color: {
              rgb: "FF000000",
            },
          },

          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },

          border: {
            top: {
              style: "thin",
              color: {
                rgb: "FF777777",
              },
            },

            left:
              indice === 0
                ? {
                    style: "thin",
                    color: {
                      rgb: "FF777777",
                    },
                  }
                : undefined,

            right:
              indice ===
              totalColumnas - 1
                ? {
                    style: "thin",
                    color: {
                      rgb: "FF777777",
                    },
                  }
                : undefined,
          },
        },
      })
    );

  /*
   * Rango centrado
   */
  const crearFilaRango = () =>
    Array.from(
      {
        length: totalColumnas,
      },
      (_, indice) => ({
        value:
          indice === columnaCentral
            ? rango || ""
            : "",

        style: {
          font: {
            name: "Arial",
            sz: 10,
            bold: false,
            color: {
              rgb: "FF777777",
            },
          },

          alignment: {
            horizontal: "center",
            vertical: "center",
            wrapText: true,
          },

          border: {
            bottom: {
              style: "thin",
              color: {
                rgb: "FF777777",
              },
            },

            left:
              indice === 0
                ? {
                    style: "thin",
                    color: {
                      rgb: "FF777777",
                    },
                  }
                : undefined,

            right:
              indice ===
              totalColumnas - 1
                ? {
                    style: "thin",
                    color: {
                      rgb: "FF777777",
                    },
                  }
                : undefined,
          },
        },
      })
    );

  /*
   * Encabezados manuales de la tabla.
   *
   * Fondo negro y texto blanco.
   */
  const filaEncabezadosTabla =
    columnas.map((columna) => ({
      value: columna.titulo,

      style: {
        font: {
          name: "Arial",
          sz: 9,
          bold: true,
          color: {
            rgb: "FFFFFFFF",
          },
        },

        fill: {
          patternType: "solid",
          fgColor: {
            rgb: "FF000000",
          },
          bgColor: {
            rgb: "FF000000",
          },
        },

        alignment: {
          horizontal:
            columna.alineacion,
          vertical: "center",
          wrapText: true,
        },

        border: {
          top: {
            style: "thin",
            color: {
              rgb: "FF000000",
            },
          },

          bottom: {
            style: "thin",
            color: {
              rgb: "FF000000",
            },
          },

          left: {
            style: "thin",
            color: {
              rgb: "FF000000",
            },
          },

          right: {
            style: "thin",
            color: {
              rgb: "FF000000",
            },
          },
        },
      },
    }));

  /*
   * Filas con los datos
   */
  const filasDatos =
    datos.map((dato) =>
      columnas.map((columna) => {
        let valor =
          dato[columna.campo];

        if (
          valor === null ||
          valor === undefined
        ) {
          valor = "";
        }

        return {
          value: valor,

          style: {
            font: {
              name: "Arial",
              sz: 9,
              color: {
                rgb: "FF000000",
              },
            },

            alignment: {
              horizontal:
                columna.alineacion,
              vertical: "top",
              wrapText: true,
            },

            border: {
              bottom: {
                style: "hair",
                color: {
                  rgb: "FFD9D9D9",
                },
              },
            },
          },
        };
      })
    );

  /*
   * Se usa un solo dataSet.
   *
   * Los encabezados forman parte de data para
   * que la librería aplique los estilos.
   */
  const multiDataSet = [
    {
      columns: columnasExcel,

      data: [
        crearFilaTitulo(),
        crearFilaVacia(),
        crearFilaOrganismo(),
        crearFilaRango(),
        crearFilaVacia(),

        filaEncabezadosTabla,

        ...filasDatos,
      ],
    },
  ];

  const botonExcel = (
    <IconButton
      title="Exportar a Excel"
      disabled={sinDatos}
    >
      <FileDownloadOutlinedIcon />
    </IconButton>
  );

  if (sinDatos) {
    return botonExcel;
  }

  const tipoArchivo =
    String(tipo)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-") ||
    "expedientes";

  return (
    <ExcelFile
      filename={`listado-${tipoArchivo}`}
      element={botonExcel}
    >
      <ExcelSheet
        dataSet={multiDataSet}
        name={
          esTramite
            ? "Trámites"
            : "Expedientes"
        }
      />
    </ExcelFile>
  );
};

export default GeneradorExcelExpedientes;